/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../../common/locale';
import '../../resources/warranty_product';
import '../../../../connect/v2/resources/error';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

const jsonData = {
  "squareup": {
    "nested": {
      "solidshop": {
        "nested": {
          "v2": {
            "nested": {
              "service": {
                "nested": {
                  "ListAllWarrantyProductsRequest": {
                    "fields": {
                      "merchantToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "productKeys": {
                        "type": "string",
                        "id": 2,
                        "rule": "repeated"
                      },
                      "limit": {
                        "type": "int32",
                        "id": 3,
                        "rule": "optional",
                        "options": {
                          "default": 25
                        }
                      },
                      "cursor": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      },
                      "storeCode": {
                        "type": "string",
                        "id": 5,
                        "rule": "optional"
                      },
                      "locale": {
                        "type": "squareup.solidshop.v2.common.Locale",
                        "id": 6,
                        "rule": "optional",
                        "options": {
                          "default": "EN_US"
                        }
                      }
                    }
                  },
                  "ListAllWarrantyProductsResponse": {
                    "fields": {
                      "warrantyProducts": {
                        "type": "squareup.solidshop.v2.resources.WarrantyProduct",
                        "id": 1,
                        "rule": "repeated"
                      },
                      "details": {
                        "type": "squareup.solidshop.v2.resources.WarrantyProductDetail",
                        "id": 2,
                        "keyType": "string"
                      },
                      "cursor": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "errors": {
                        "type": "squareup.connect.v2.resources.Error",
                        "id": 4,
                        "rule": "repeated"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.solidshop?.nested?.v2?.nested?.service?.nested?.ListAllWarrantyProductsRequest && !$root.nested?.squareup?.nested?.solidshop?.nested?.v2?.nested?.service?.nested?.ListAllWarrantyProductsResponse) {
	$root.addJSON(jsonData);
}

/**
 * SOURCE ListAllWarrantyProductsRequest @ squareup/solidshop/v2/service/warranty_products/list_all_warranty_products.proto at 12:1
 */
export const ListAllWarrantyProductsRequest = $root.lookupType('squareup.solidshop.v2.service.ListAllWarrantyProductsRequest');
fixType(ListAllWarrantyProductsRequest);
Builder.createAndAttachToType(ListAllWarrantyProductsRequest);
/**
 * SOURCE ListAllWarrantyProductsResponse @ squareup/solidshop/v2/service/warranty_products/list_all_warranty_products.proto at 32:1
 */
export const ListAllWarrantyProductsResponse = $root.lookupType('squareup.solidshop.v2.service.ListAllWarrantyProductsResponse');
fixType(ListAllWarrantyProductsResponse);
Builder.createAndAttachToType(ListAllWarrantyProductsResponse);
